import { useEffect, useRef, useState } from "react";
import useOpenAIWebRTC from "./WebRTCSession";
import { API_AUTH_TYPES } from "../../../../../api/apiConstants";

export default function VoiceAgentPanel({ role = API_AUTH_TYPES.ADVISOR, conversationId = null, onUserTranscript, onAssistantTranscript }) {
    const [voice, setVoice] = useState(() => localStorage.getItem('parabot_voice') || 'alloy');
    const { connect, disconnect, connected, error, remoteAudioRef } = useOpenAIWebRTC({ role, conversationId, voice, onUserTranscript, onAssistantTranscript });
    const audioContainerRef = useRef(null);
    const [initializing, setInitializing] = useState(false);
    console.log('[PARABOT-VOICE] VoiceAgentPanel conversationId:', conversationId);
    useEffect(() => {
        if (remoteAudioRef.current && audioContainerRef.current) {
            // Attach the audio element to the DOM once created
            const el = remoteAudioRef.current;
            if (!audioContainerRef.current.contains(el)) {
                audioContainerRef.current.appendChild(el);
            }
        }
    }, [remoteAudioRef, connected]);

    const handleStart = async () => {
        setInitializing(true);
        try {
            await connect();
        } finally {
            setInitializing(false);
        }
    };

    const handleStop = () => {
        disconnect();
    };

    const handleVoiceChange = (e) => {
        const v = e.target.value;
        setVoice(v);
        try { localStorage.setItem('parabot_voice', v); } catch (_) { }
    };

    return (
        <div className="flex flex-col gap-2">
            <div className="flex items-center gap-2">
                <select value={voice} onChange={handleVoiceChange} disabled={connected || initializing} className="px-2 py-1 border rounded text-sm">
                    {['alloy', 'ash', 'ballad', 'cedar', 'coral', 'echo', 'marin', 'sage', 'shimmer', 'verse'].map(v => (
                        <option key={v} value={v}>{v.charAt(0).toUpperCase() + v.slice(1)}</option>
                    ))}
                </select>
                {!connected ? (
                    <button onClick={handleStart} disabled={initializing} className="px-3 py-1 bg-blue-600 text-white rounded">
                        {initializing ? "Starting…" : "Start Voice"}
                    </button>
                ) : (
                    <button onClick={handleStop} className="px-3 py-1 bg-gray-600 text-white rounded">Stop Voice</button>
                )}
                <span className={`text-sm ${connected ? 'text-green-600' : 'text-gray-500'}`}>
                    {connected ? "Connected" : "Idle"}
                </span>
            </div>
            {error && <div className="text-red-600 text-sm">{error}</div>}
            <div ref={audioContainerRef} />
        </div>
    );
}


